import {sumLaborSection} from './laborSection';
import {sumMaterialSection} from './materialSection';
import {sumOtherCostSection} from './otherCostSection';
import {sumOverheadSection} from './overheadSection';
import {numberToFixed} from '../../helpers';
import {percentOfTotal,convertDecimal2} from '../../helpers';

export const createSummaryData = (
  cbdLineItems,
  cbdHeader,
  totalFob,
  additionalSummaryFields
) => {
  if (!cbdLineItems) {
    return null;
  }
  const costSheetotherCost = additionalSummaryFields['Other Cost'] !== ''?
      additionalSummaryFields['Other Cost']:(additionalSummaryFields['Other Adjustment Cost'] !== 0.0)
          ?additionalSummaryFields['Other Adjustment Cost']:0.0;
  const materialCostSummaryCostBreakdown = sumMaterialSection (
    cbdLineItems.costsheetMaterialCostLineItem,
    cbdLineItems.costsheetLandedCostUsd,
    cbdHeader
  );

  const otherCostSummaryCostBreakdown = sumOtherCostSection(
    additionalSummaryFields['Other Adjustment Cost'],
    additionalSummaryFields['Glidepath Cost'],
      costSheetotherCost
    );

  const laborCostSummaryCostBreakdown = sumLaborSection (
    cbdLineItems.costsheetBillOfLaborLineItemDetails,
    cbdLineItems.costsheetLaborCostUsd,
    cbdHeader
  );

  const overheadCostSummaryCostBreakdown = sumOverheadSection (
    cbdLineItems,
    cbdLineItems.nikeTotalOverheadCost
  );

  return {
    'Material Cost': {
      sectionSummary: {
        '% of FOB Cost': percentOfTotal (
          totalFob,
          cbdLineItems.costsheetLandedCostUsd
        ),
        'Reference Date': additionalSummaryFields['Material Reference Date'],
        cost: cbdLineItems.costsheetLandedCostUsd,
        subSections: materialCostSummaryCostBreakdown,
      },
    },
    'Labor Cost': {
      sectionSummary: {
        'Total In-House Cost':`${cbdLineItems.costsheetInhouseLaborProcessCost?convertDecimal2 (cbdLineItems.costsheetInhouseLaborProcessCost):''}`,
        'Total Outsourced Cost':`${cbdLineItems.costsheetOutsourcedLaborProcessCost?convertDecimal2(cbdLineItems.costsheetOutsourcedLaborProcessCost):''}`,
        'Total Labor Minutes':cbdLineItems.costsheetLaborMinutes,
        '% of FOB Cost': percentOfTotal (
          totalFob,
          cbdLineItems.costsheetLaborCostUsd
        ),
        FEM: `${additionalSummaryFields['FEM']} ${additionalSummaryFields['FEM Effective Date'] ? '(Effective on ' + additionalSummaryFields['FEM Effective Date'] + ')' : ''}`,
        'Factory Labor Rate': `$${numberToFixed (additionalSummaryFields['Factory Labor Rate'], 4)}/min ${additionalSummaryFields['Labor Rate Effective Date'] ? '(Effective on ' + additionalSummaryFields['Labor Rate Effective Date'] + ')' : ''}`,
        'Reference Date': additionalSummaryFields['Labor Reference Date'],
        cost: cbdLineItems.costsheetLaborCostUsd,
        subSections: laborCostSummaryCostBreakdown,
      },
    },
    'Overhead Cost': {
      sectionSummary: {
        '% of FOB Cost': percentOfTotal (
          totalFob,
          cbdLineItems.nikeTotalOverheadCost
        ),
        'Other Overhead Percent': `${typeof additionalSummaryFields['Other Overhead Percent'] === 'number' ? additionalSummaryFields['Other Overhead Percent'].toFixed (2) : ''}% ${additionalSummaryFields['Other Overhead Percent Effective Date'] ? '(Effective on ' + additionalSummaryFields['Other Overhead Percent Effective Date'] + ')' : ''}`,
        'Reference Date': additionalSummaryFields['Overhead Reference Date'],
        cost: cbdLineItems.nikeTotalOverheadCost,
        subSections: overheadCostSummaryCostBreakdown,
      },
    },
    'Profit Cost': {
      sectionSummary: {
        '% of FOB Cost': percentOfTotal (
          totalFob,
          cbdLineItems.nikeFactoryProfitCost
        ),
        'Profit Rate Percent': `${typeof additionalSummaryFields['Profit Rate Percent'] === 'number' ? additionalSummaryFields['Profit Rate Percent'].toFixed (1) : ''}% ${additionalSummaryFields['Profit Rate Percent Effective Date'] ? '(Effective on ' + additionalSummaryFields['Profit Rate Percent Effective Date'] + ')' : ''}`,
        'Reference Date': additionalSummaryFields['Profit Reference Date'],
        cost: typeof cbdLineItems.nikeFactoryProfitCost === 'number'
          ? cbdLineItems.nikeFactoryProfitCost
          : '',
      },
    },
    'Other Cost': {
          sectionSummary: {
              '% of FOB Cost': percentOfTotal (
                  totalFob,
                  costSheetotherCost
              ),
              'Other Adjustment Description': additionalSummaryFields[
                  'Other Adjustment Cost Description'
                  ],
              cost: costSheetotherCost,
              subSections: otherCostSummaryCostBreakdown,
          },
      },
    // 'Other Cost': {
    //   sectionSummary: {
    //     '% of FOB Cost': percentOfTotal (
    //       totalFob,
    //       additionalSummaryFields['Other Cost']
    //     ),
    //      'Other Adjustment Cost':  typeof additionalSummaryFields['Other Adjustment Cost'] ===
    //      'number'
    //          ? `$` +convertDecimal(additionalSummaryFields['Other Adjustment Cost']):'',
    //     'Other Adjustment Description': additionalSummaryFields[
    //       'Other Adjustment Cost Description'
    //     ],
    //     cost: typeof additionalSummaryFields['Other Cost'] ===
    //       'number'
    //       ? additionalSummaryFields['Other Cost']
    //       : '',
    //       // 'Glidepath Cost': cbdHeader.costsheetGlidepathCost?`$` + convertDecimal (
    //       //     cbdHeader.costsheetGlidepathCost):'',
    //   },
    //     subSections:otherCostSummaryCostBreakdown,
    // },
    'Tooling Cost': {
      sectionSummary: {
        // 'Effective Date': additionalSummaryFields['Tooling Effective Date'],
        '% of FOB': percentOfTotal (totalFob, cbdHeader.costsheetToolingCost),
        cost: typeof cbdHeader.costsheetToolingCost === 'number'
          ? cbdHeader.costsheetToolingCost
          : '',
      },
    },
  };
};



// WEBPACK FOOTER //
// ./src/dataMappingUIHelpers/subSectionMapping/subSections.js